import { Table } from "antd";
import { DelayStepSummary } from "components/CC/RunHistory/StepDetails/utils/types";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

import type { ColumnsType } from "antd/es/table";

interface DelayRow {
    key: string;
    label: string;
    value: string;
}

export interface StepDetailDelayProps {
    extractedData: DelayStepSummary;
}

export const StepDetailDelay: FC<StepDetailDelayProps> = ({ extractedData }) => {
    const { t } = usePaldockTranslation("drawers.step-detail.delay");

    const rows: DelayRow[] = [
        {
            key: "delay_seconds",
            label: t("delay_seconds"),
            value: extractedData.delaySeconds != null ? String(extractedData.delaySeconds) : "-",
        },
    ];

    const columns: ColumnsType<DelayRow> = [
        { dataIndex: "label", key: "label" },
        { dataIndex: "value", key: "value" },
    ];

    return (
        <DrawerCollapsible title={t("data")}>
            <Table
                columns={columns}
                dataSource={rows}
                pagination={false}
                size="small"
                bordered={false}
                showHeader={false}
            />
        </DrawerCollapsible>
    );
};
